/* set jquery globals */
const $ = window.jQuery;
const jQuery = window.jQuery;

/* start a vimeo video by adding autoplay to the iframe src */
$('body').on('click', '[data-start="video"]', function(e){
	e.preventDefault();
	var videoFrame = $($(this).attr('href'));
		src = videoFrame.attr('src');

	$('.atd-video-playing').each(function() {
		$(this).attr('src', $(this).attr('src').replace('?autoplay=1', ''));
		$(this).removeClass('atd-video-playing');
	});

	videoFrame.attr('src', src + '?autoplay=1').addClass('atd-video-playing');
});
